import { AttackPattern, PatternState } from '../AttackPattern.js';

/**
 * Chorus of the Deep (The Undersong, Act II — phase 2). The finale's "true
 * form" move: a rotating spiral of arms that alternates tone (warm/cold) every
 * volley, so the Antiphon's polarity rule runs at spiral density — you are
 * constantly re-attuning as the arms sweep. It reuses the toned-bullet
 * mechanic (BossBullet.tone / SpawningSystem collision) rather than inventing
 * anything; the finale's job is to compose Act II's textures at pressure, not
 * add a sixth.
 */
export class ChorusOfTheDeep extends AttackPattern {
  constructor({ minPhase = 2, config }) {
    super({ name: 'Chorus of the Deep', telegraphDuration: 0.9, activeDuration: 3.0, minPhase });
    this.config = config;
    // This card writes its own bullet tones, so §B7's boss-level card tone
    // must not overwrite them (see SpawningSystem._overlayFor).
    this.tonesOwnBullets = true;
    this._angle = 0;
    this._fireTimer = 0;
    this._tone = 'warm';
  }

  onActiveStart() {
    this._angle = Math.random() * Math.PI * 2;
    this._fireTimer = 0;
    this._tone = 'warm';
  }

  onActiveTick(dt, boss, _player, pool) {
    this._angle += this.config.spinSpeed * dt;
    this._fireTimer -= dt;
    if (this._fireTimer > 0) return;
    this._fireTimer = this.config.fireInterval;

    const { arms, speed, damage, warmColor, coldColor, mismatchBonus } = this.config;
    const color = this._tone === 'warm' ? warmColor : coldColor;
    for (let a = 0; a < arms; a++) {
      const angle = this._angle + (a / arms) * Math.PI * 2;
      pool.fire({
        x: boss.x,
        y: boss.y,
        vx: Math.cos(angle) * speed,
        vy: Math.sin(angle) * speed,
        radius: 2.6,
        damage,
        color,
        lifetime: 5,
        tone: this._tone,
        mismatchBonus,
      });
    }
    // Alternate the tone each volley so no attunement is safe for long.
    this._tone = this._tone === 'warm' ? 'cold' : 'warm';
  }

  getVisual(boss) {
    if (this.state !== PatternState.TELEGRAPH) return null;
    return {
      kind: 'toneSpiral',
      x: boss.x,
      y: boss.y,
      arms: this.config.arms,
      tone: this._tone,
      color: this._tone === 'warm' ? this.config.warmColor : this.config.coldColor,
    };
  }
}
